import { MatchResult } from '../types';

interface Props {
  result: MatchResult;
  onPlayAgain: () => void;
  onMenu: () => void;
  onLeaderboard: () => void;
}

export default function GameOverScreen({ result, onPlayAgain, onMenu, onLeaderboard }: Props) {
  return (
    <div className="screen">
      <div className="arcade-title">TIME'S UP</div>
      <div className="panel" style={{ width: 380 }}>
        <div style={{ textAlign: 'center', fontFamily: 'var(--font-display)', fontSize: 28, color: 'var(--horizon)', marginBottom: 8 }}>
          {result.score.toLocaleString()}
        </div>
        <div className="arcade-subtitle" style={{ textAlign: 'center', marginBottom: 16 }}>
          Final Score
        </div>
        <div className="result-stats">
          <div className="result-stat">
            <span className="value">{result.hits}</span>
            <span className="label">Hits</span>
          </div>
          <div className="result-stat">
            <span className="value">{result.shots}</span>
            <span className="label">Shots</span>
          </div>
          <div className="result-stat">
            <span className="value">{Math.round(result.accuracy * 100)}%</span>
            <span className="label">Accuracy</span>
          </div>
          <div className="result-stat">
            <span className="value">{result.coinsEarned ?? '-'}</span>
            <span className="label">Coins Earned</span>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button className="arcade-btn" onClick={onPlayAgain}>
            Play Again
          </button>
          <button className="arcade-btn secondary" onClick={onLeaderboard}>
            View Leaderboard
          </button>
          <button className="arcade-btn secondary" onClick={onMenu}>
            Main Menu
          </button>
        </div>
      </div>
    </div>
  );
}
